import {Priority} from '../../api/warning-and-scoring/types/warning-and-scoring.types'

export interface EventsFilterCriteria {
    priorities?: Priority[]
    sources?: string[]
    locations?: string[]
    eventType?: string
    assetName?: string
    fromCreatedAt?: string
    toCreatedAt?: string
    states?: string[]
}

export const DEFAULT_EVENTS_FILTER_CRITERIA: EventsFilterCriteria = {
    states: ['active'],
}

export interface EventsFilterForUserPref extends EventsFilterCriteria {
    selectedFilterName: string
}
